<template>
  <div>
    <div class="header">
      <header-tag :title="'微信绑定'"></header-tag>
    </div>
    <div class="form-body" v-show="showBindNext">
      <div class="form-top">开启微信扫码安全验证请先验证短信验证码</div>
      <div class="form-left">
        <p>短信验证码:</p>
        <p></p>
      </div>
      <div class="form-right">
        <p style="position: relative;">
          <input type="text" placeholder="请输入验证码" v-model="smsCode" />
          <span v-show="show" @click="getSmsCode">获取验证码</span>
          <span v-show="!show">{{ count }} s</span>
        </p>
      </div>
    </div>
    <div class="form-body" v-show="!showBindNext">
      <div id="wxImg"></div>
    </div>
    <div class="footer" v-show="showWxCode">
      <span v-text="wrongText" ref="wxWrong"></span>
      <button @click="showWxBind2">下一步</button>
      <button @click="closeWxBind">取消</button>
    </div>
    <bind-img :show="showImg" @sendShow="showImgModals"></bind-img>
  </div>
</template>
<script>
import { validateWxSmsCode } from "@/requests/safe";
import { sendWxSmsCode } from "@/requests/safe";
import HeaderTag from "_c/tagTitle/headerTag";
import bindImg from "./bindImg";
export default {
  name: "changeWx",
  components: {
    HeaderTag,
    bindImg
  },
  data () {
    return {
      showPwd: false,
      showBindNext: true, //微信前去绑定下一步
      show: true,
      count: "",
      timer: null,
      showImg: false,
      smsCode: "",
      wrongText: "",
      showWxCode: true
    };
  },
  methods: {
    //关闭修改密码弹框
    closePwd () {
      this.showPwd = false;
      this.wrongText = "";
      this.$emit("showPwd", false);
    },
    //验证码倒计时
    countDown () {
      const TIME_COUNT = 60;
      if (!this.timer)
      {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT)
          {
            this.count--;
          } else
          {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 显示微信绑定下一步
    async showWxBind2 () {
      this.wrongText = "";
      let smsRe = this.$validateCenter.smsCode(this.smsCode);
      if (smsRe.res == false)
      {
        this.wrongText = smsRe.msg;
        this.$domFn.shake(this.$refs.wxWrong);
        return false;
      }
      let obj = {
        smsCode: this.smsCode
      };
      let res = await validateWxSmsCode(obj);
      if (res.code == 200)
      {
        this.showBindNext = false;
        this.wrongText = "";
        this.showWxCode = false;
      } else
      {
        this.wrongText = res.msg;
        this.$domFn.shake(this.$refs.wxWrong);
      }
    },
    // 关闭微信绑定弹框
    closeWxBind () {
      this.showWx = false;
      this.showBindWX = true;
      this.showBindNext = true;
      this.$emit("showWx", false);
    },
    wxBind () {
      /* eslint-disable */
      var obj = new WxLogin({
        id: "wxImg",
        appid: "wxebbc91ae550cfb80",
        scope: "snsapi_login",
        redirect_uri: "https://www.weihudashi.com/api/wx/bindWx.htm",
        state: "https://www.weihudashi.com/home/accountSafe",
        style: "black",
        href: "https://www.weihudashi.com/css/weixin.css"
      });
    },
    showImgModals (data) {
      this.showImg = data;
    },
    async getSmsCode () {
      let res = await sendWxSmsCode();
      if (res.msg == "发送成功")
      {
        this.countDown();
      } else
      {
        this.wrongText = res.msg;
        this.$domFn.shake(this.$refs.wxWrong);
      }
    }
  },
  mounted () {
    this.wxBind();
  }
};
</script>
<style lang="scss" scoped>
.form-body {
  overflow: hidden;
  width: 100%;
  padding: 10px 0px 20px 0px;

  .form-top {
    width: 100%;
    padding-left: 75px;
    line-height: 50px;
    text-align: left;
  }

  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }

  .form-right {
    float: left;
    padding-left: 15px;
    width: 300px;
    text-align: left;
    line-height: 40px;

    // background-color: #0ff;
    input {
      width: 100%;
      height: 30px;
      padding-left: 10px;
      border: 1px solid #d9dee4;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      // transform: translate(240px,-40px);
      color: rgb(0, 102, 204);
      cursor: pointer;
    }
  }

  .img-code {
    position: absolute;
    top: 130px;
    right: 90px;
    width: 140px;
    height: 95px;
  }
}

.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}

.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;

  button {
    width: 100px;
    line-height: 30px;
  }

  button {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }

  button:last-child {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
    color: #000;
  }

  span {
    float: left;
    padding-left: 50px;
    line-height: 30px;
    color: #f00;
  }
}
</style>
